import type UserGameDetail from "~/libs/interfaces/UserGameDetail";
import userGameDetailFactory from "~/libs/factories/UserGameDetailFactory";
import type UserGameRegisterPayload from "~/libs/interfaces/UserGameRegisterPayload";
import type GameUserLocal from "~/libs/interfaces/GameUserLocal";
import type {Ref} from "vue";
import type UserCheckWinPayload from "~/libs/interfaces/UserCheckWinPayload";
import type UserPickupWinPayload from "~/libs/interfaces/UserPickupWinPayload";

const userGameDetailStore = (type: string = 'main') => defineStore(`user-game-detail-${type}`, {
  state: () => {
    const state: {
      isLoading: Ref<boolean>,
      isGameUserLoading: Ref<boolean>,
      isWinCheckLoading: Ref<boolean>,
      lastSync: Record<string, Date>,
      userGameDetail: UserGameDetail
    } = {
      isLoading: ref(false),
      isGameUserLoading: ref(false),
      isWinCheckLoading: ref(false),
      lastSync: {},
      userGameDetail: reactive({})
    }
    return state
  },
  getters: {

  },
  actions: {
    async fetchUserGameDetail(gameSlug: string): Promise<void> {
      const userStore = useUserStore()
      const gamesStore = useGamesStore(gameSlug)
      const gameDrawsStore = useGameDrawsStore(gameSlug)

      // Fetch game
      const filterMainGame = {
        slugs: [gameSlug],
      }
      gamesStore.setLimit(1)
      await gamesStore.fetchGames(filterMainGame)
      const gameDocumentId = gamesStore.game?.documentId

      // Fetch active draw
      try {
        await gameDrawsStore.fetchActiveGameDraw(gameDocumentId)
      } catch (e) {}

      // Fetch games
      try {
        await userStore.fetchUserGame(gameDocumentId)
      } catch (e) {}

      // Store state
      this.userGameDetail = userGameDetailFactory.createUserGameDetail(
        userStore.user,
        gamesStore.game,
        gameDrawsStore.getActiveDraw(gameDocumentId),
        userStore.getUserGame(gameDocumentId)
      )
    },
    /**
     * Register to game
     * @param payload
     */
    async registerToGame(payload: UserGameRegisterPayload): Promise<GameUserLocal | null> {
      this.isGameUserLoading = true
      const userStore = useUserStore()
      try {
        const result = await userStore.registerToGame(payload)
        this.userGameDetail.gameUser = result
        if (result?.user) {
          userStore.user = result?.user
          this.userGameDetail.user = result?.user
        }
        this.isGameUserLoading = false
      } catch (e) {
        this.isGameUserLoading = false
        throw e
      }
      return this.userGameDetail.gameUser || null
    },
    /**
     * Check user win
     * @param payload
     */
    async checkWin(payload: UserCheckWinPayload): Promise<GameUserLocal | null> {
      this.isWinCheckLoading = true
      try {
        const gameDrawsStore = useGameDrawsStore()
        const result = await gameDrawsStore.checkWin(payload.game)
        this.userGameDetail.activeDraw = result
        this.isWinCheckLoading = false
      } catch (e) {
        this.isWinCheckLoading = false
        throw e
      }

      return this.userGameDetail.activeDraw || null
    },
    /**
     * Pickup win
     * @param payload
     */
    async pickupWin(payload: UserPickupWinPayload): Promise<GameUserLocal | null> {
      this.isGameUserLoading = true
      try {
        const gameDrawsStore = useGameDrawsStore()
        const result = await gameDrawsStore.pickupWin(payload)
        this.userGameDetail.activeDraw = result
        this.isGameUserLoading = false
      } catch (e) {
        this.isGameUserLoading = false
        throw e
      }

      return this.userGameDetail.activeDraw || null
    }
  },
})

export const useUserGamesDetailStore = (type?: string) => {
  return userGameDetailStore(type)()
}

